// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.payment-logo {
  height: 23px;
  margin-left: 8px;
}

.bigfish-options {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%; /* vagy konkrét magasság, pl. 200px */
}

mat-radio-button {
  display: flex;
  align-items: center; /* Vertikálisan középre igazítja a radio button tartalmát */
  margin: 5px 0; /* Opciók közötti távolság beállítása */
}

.col-horizontal-center {
  display: flex;
  align-items: center; /* Vertikálisan középre igazítja a div tartalmát (kép és szöveg) */
}

.col-horizontal-center-images {
  display: flex;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  /* justify-items: center; */
}

.payment-logo-3 {
  height: 23px;
}

.bigfish-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.nevogate-logo {
  height: 45%;
}

hr.payment {
  border: 1px solid rgb(229, 229, 229);
  width: 50%;
  margin: 0 auto; /* Ez teszi középre vízszintesen */
}

.payment-radio-group {
  display: flex;
  flex-direction: column;
}

.payment-radio-button {
  margin-bottom: 1em;
}

.payment-option-content {
  width: 100%;
  margin-left: 5px;
}

.szep-card-option {
  display: flex;
  flex-direction: column;
  align-items: center;
}

::ng-deep .mat-radio-button-label-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
